import { FEATURES } from '@constants/Text'

// Override de desenvolvimento: para testar a home por IA sem o backend ligar a
// flag, rode no console `localStorage.setItem('homeia', '1')` e recarregue.
// O override só LIGA a feature — nunca desliga a home real de produção. Não
// tem efeito em build de produção (NODE_ENV === 'production') — só a flag
// real do backend liga a home por IA lá.
export const DEV_OVERRIDE_KEY = 'homeia'

/**
 * Diz se a FLAG da home por IA está ligada — a real (backend) ou o override
 * de desenvolvimento via localStorage. Este helper lê SÓ a flag; a régua de
 * quem vê a imersiva é `podeVerIaDriven` (`global/utils/chat-ia-widget-visivel`),
 * que compõe esta flag com `podeUsarChatIa` E exige a navegação 2026
 * (`isNav2026Enabled`) — a v1 não renderiza `meta.imersivo`.
 * @param {Object} access store.getters['parameters/show']
 * @returns {boolean}
 */
export function isHomeIaEnabled(access) {
  const show = access || {}
  if (show[FEATURES.HOME_IA]) return true
  if (process.env.NODE_ENV === 'production') return false
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(DEV_OVERRIDE_KEY) === '1'
    )
  } catch {
    // localStorage indisponível (modo privado/bloqueado): mantém a feature desligada.
    return false
  }
}
